/**
 * The ONE place money becomes a string. Every currency render in the app goes
 * through here — never call .toLocaleString on an amount in a component.
 *
 * Rules this file enforces (see docs/design-system-audit.md, Tell #2):
 * - exactly 2 fraction digits (Intl's default max is max(min, 3), which let
 *   sub-cent values render "$1,234.568" in a two-decimal column), or exactly
 *   0 for whole-dollar summary figures
 * - U+2212 MINUS SIGN, not the ASCII hyphen — correct width next to digits
 * - the sign precedes the "$" so negative and positive amounts share a
 *   decimal-aligned column under tabular figures
 */

const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const USD_WHOLE = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export interface MoneyOptions {
  /** Round to whole dollars — summary tiles and axis labels only. */
  whole?: boolean;
  /** Always show a leading + on positive amounts (flow deltas). */
  signed?: boolean;
}

export function money(value: number | null | undefined, opts: MoneyOptions = {}): string {
  if (value == null || Number.isNaN(value)) return '—';
  const fmt = opts.whole ? USD_WHOLE : USD;
  const abs = fmt.format(Math.abs(value));
  if (value < 0) return `−${abs}`;
  return opts.signed ? `+${abs}` : abs;
}
